import * as React from "react";
const SvgFiRrFilterSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-filter-slash_svg__a)">
      <path
        fill="#062147"
        d="m23.707 22.293-7.414-7.414 4.345-4.478a4.93 4.93 0 0 0 1.4-3.45 4.957 4.957 0 0 0-4.95-4.952H6.95c-.973 0-1.909.297-2.712.825L1.707.294A.999.999 0 1 0 .293 1.706l22 22a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414M6.951 4h10.137a2.955 2.955 0 0 1 2.951 2.951c0 .772-.296 1.503-.835 2.058l-4.324 4.456L5.703 4.29C6.093 4.107 6.513 4 6.95 4zm8.05 15v4a1.001 1.001 0 0 1-1.6.8l-4-3A1 1 0 0 1 9 20v-3.844l-5.6-5.754a4.9 4.9 0 0 1-1.004-1.51 1 1 0 0 1 1.84-.784c.143.336.344.64.598.9l5.882 6.044a1 1 0 0 1 .283.697v3.75l2 1.5v-2A1 1 0 1 1 15 19"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-filter-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFilterSlash;
